
<template>
    <div id="app">
        <Navigation />
        <transition >
            <router-view />
        </transition>
        <footer class="footer">
            <div class="content has-text-centered">
            <img
                    width="225"
                    src="./assets/images/logos/logo-m.png"
                    alt="My Meatloaf Logo"
                >
                <div>                
                    <strong>MyMeatloaf</strong> &#169; 2020
                </div>
                <div>                
                    <small>Literally, Just the Recipe</small>
                </div>
            </div>
        </footer>
    </div>
</template>



<script>
import Navigation from './components/Navigation'
export default {
    name: 'app',
    data() {
        return {
            prevHeight: 0
        };
    },
    components: {
        'Navigation': Navigation
    },
    methods: {
        beforeLeave(element) {
            this.prevHeight = getComputedStyle(element).height;
        },
        enter(element) {
            //document.getElementById('loader').style.display = 'block';
            const { height } = getComputedStyle(element);

            element.style.height = this.prevHeight;

            setTimeout(() => {
                element.style.height = height;
            });
        },
        afterEnter(element) {
            //document.getElementById('loader').style.display = 'none';
            element.style.height = 'auto';
        }
    }
}
</script>